<template>
  <table class="info info--importdata">
    <thead>
      <tr>
        <th>Navn</th>
        <th>Varenumre</th>
        <th>Administrationsveje</th>
        <th>Indholdsstoffer</th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, itemIndex) in list"
        :key="itemIndex"
      >
        <td :style="{width: '20%'}">
          {{ item.name }}
        </td>
        <td :style="{width: '20%'}">
          <span
            v-for="(text, textIndex) in item.productNumbers"
            :key="textIndex"
            class="badge"
            :class="{'badge--success': text.added, 'badge--danger': text.removed}"
          >
            {{ text.value }}
          </span>
        </td>
        <td :style="{width: '25%'}">
          <span
            v-for="(text, textIndex) in item.routeOfAdministrations"
            :key="textIndex"
            class="badge"
            :class="{'badge--success': text.added, 'badge--danger': text.removed}"
          >
            {{ text.value }}
          </span>
        </td>
        <td :style="{width: '25%'}">
          <span
            v-for="(text, textIndex) in item.substances"
            :key="textIndex"
            class="badge"
            :class="{'badge--success': text.added, 'badge--danger': text.removed}"
          >
            {{ text.value }}
          </span>
        </td>
        <td
          :style="{width: '10%'}"
          class="textRight"
        >
          <span
            class="alertIcon"
            title="Der ligger allerede en fremtidig version på dette præparat"
            v-if="item.hasFutureVersion"
          >
            <svg
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            ><path d="M14.18,15.4H9.82V0h4.36Zm0,4.24H9.82V24h4.36Z" /></svg>
          </span>
          <a
            href="#"
            @click.prevent="$emit('click', item)"
            class="underline"
          >Opret version</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
    name: 'ImportPreparationUpdatedList',
    props: {
        list: { type: Array, required: true },
    },
};
</script>

<style lang="scss" scoped>
.textRight {
    text-align: right;
}

.added {
    font-weight: bold;
    color: green;
}
.removed {
    font-weight: bold;
    color: red;
    text-decoration: line-through;
}
.alertIcon {
  align-items: center;
  background-color: rgb(232, 176, 1);
  display: inline-flex;
  height: 1rem;
  justify-content: center;
  margin: 0 0.5rem;
  width: 1rem;

  svg {
    height: 0.5rem;
    width: auto;
  }
}
</style>
